/**
 * Local read contract for invoice lookup within KsefOutgoing feature.
 * Isolates operator console flow from upstream Invoice DTO changes.
 */
export interface KsefOutgoingInvoiceLookup {
  id: number;
  invoiceNumber: string;
  buyerCountryIso: string | null;
  buyerNip: string | null;
  isBuyerVatEu: boolean | null;
  buyerIsJst: boolean | null;
}

export interface KsefOutgoingInvoiceLookupSource {
  id: number;
  invoiceNumber?: string | null;
  buyerCountryIso?: string | null;
  buyerNip?: string | null;
  isBuyerVatEu?: boolean | null;
  buyerIsJst?: boolean | null;
}

const normalizeText = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

const normalizeCountryIso = (value: string | null | undefined): string | null => {
  const normalized = normalizeText(value);
  return normalized ? normalized.toUpperCase() : null;
};

export const mapInvoiceToKsefOutgoingLookup = (
  invoice: KsefOutgoingInvoiceLookupSource | undefined | null
): KsefOutgoingInvoiceLookup | undefined => {
  if (!invoice) {
    return undefined;
  }

  return {
    id: invoice.id,
    invoiceNumber: normalizeText(invoice.invoiceNumber) ?? `#${invoice.id}`,
    buyerCountryIso: normalizeCountryIso(invoice.buyerCountryIso),
    buyerNip: normalizeText(invoice.buyerNip),
    isBuyerVatEu: typeof invoice.isBuyerVatEu === 'boolean' ? invoice.isBuyerVatEu : null,
    buyerIsJst: typeof invoice.buyerIsJst === 'boolean' ? invoice.buyerIsJst : null,
  };
};
